import { Environment } from "src/app/classes/flow/base/Environment";

export const ENVIRONMENT: Environment = {
  PRODUCTION: false,
  ORGANISATION: "Fixteam",
  API_URL: "https://dev.api.epf.emmengeeftenergie.nl/",
  SOCIALS: {
    SLOGAN: "Wij hebben het zo voor u gefixt",
    LINKS: {
      MAIN: "https://www.emmengeeftenergie.nl/",
      PRIVACY: "https://www.emmengeeftenergie.nl/Beheer/Privacyverklaring/default.aspx",
      DISCLAIMER: "",
    },
  },
  PORTAL_URL: "https://dev.portal.emmengeeftenergie.nl/",
  EXTRA_TRANSLATIONS_SUFFIX: [".fixteam"],
  MODULES: [
    "AREA_ACTIONS",
    "SHOW_ADDRESSDETAILS_TO_COACH_ROLE",
    "COACH_FINISH_REQUEST",
    "SHOW_ANOTHER_COACHES_ECS",
    "NOTE",
    "EDIT_ENERGY_CONSULT",
    "SHOW_CONTACT_INFO_ON_NEW_REQUESTS",
    "PHONE_NUMBER_REQUIRED",
    "HIDE_AREA_ACTIONS_NEW_REQUEST_PAGE",
    "NEW_REQUEST_COACH",
    "NEW_REQUEST_COORDINATOR",
    "REPORT_CATEGORIES",
    "STATISTICS_DASHBOARD",
    "CKD_SUBF",
    "ALLOW_HISTORIC_APPOINTMENTS",
    "CUSTOM_SPLIT_HEADER_LOGO",
    "MAIL_TIMELINE",
    "FILLED_REQUEST_REDIRECT", //redirect in coach energyconsult comp
    "DM",
  ],
  AREA_OF_OPERATIONS: {
    MATCHES: [{ type: "include", key: "provincienaam", value: ["DRENTHE"] }],
  },
  ALLOWED_SPECIALTIES: [11],
  CUSTOM_HEADER_LOGOS: [
    {
      urls: [
        {
          name: "COACH_EMMEN",
          url: "https://dev.coach.emmengeeftenergie.nl/",
          urlType: "external",
          roles: ["coordinator"],
          default: false,
        },
        {
          name: "",
          url: "/",
          urlType: "internal",
          roles: ["guest", "resident"],
          default: false,
        },
        {
          name: "",
          url: "/content",
          urlType: "internal",
          roles: [],
          default: true,
        },
      ],
      imageRoute: "assets/organisation/images/custom_header_logo/emmengeeftenergie-logo.png",
    },
    {
      urls: [
        {
          name: "FIXTEAM_EMMEN",
          url: "/",
          urlType: "internal",
          roles: ["coordinator"],
          default: false,
        },
        {
          name: "",
          url: "/",
          urlType: "internal",
          roles: ["guest", "resident"],
          default: false,
        },
        {
          name: "",
          url: "/content",
          urlType: "internal",
          roles: [],
          default: true,
        },
      ],
      imageRoute: "assets/organisation/images/custom_header_logo/fixteam-logo.png",
    },
  ],
  REDIRECTS: [["coachEnergyConsultComponent", "https://dev.coach.emmengeeftenergie.nl/request", "Doorverwijzen naar energie-coaches"]],
  DEFAULT_LOGIN_VIEW: null,
};
